import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const createContract = (params) => {
  return Api(endPoints.createContract, params, requestType.POST);
};

const createDuplicateContract = (params) => {
  return Api(endPoints.generateDuplicateContract, params, requestType.POST);
};

const updateContract = (id, params) => {
  return Api(`${endPoints.updateContract}/${id}`, params, requestType.PUT);
};

const updateContractStatuses = (id, params) => {
  return Api(
    `${endPoints.updateContractStatuses}/${id}`,
    params,
    requestType.PUT
  );
};

const sendContractPdf = (params) => {
  return Api(endPoints.sendContractPdf, params, requestType.POST);
};

const exportContract = (params) => {
  return Api(endPoints.exportContract, null, requestType.GET);
};

const getfollowUpDates = (ids = []) => {
  const url =
    ids.length > 0
      ? `${endPoints.getfollowUpDates}?agent=${ids.join(",")}`
      : endPoints.getfollowUpDates;

  return Api(url, null, requestType.GET);
};

const getAllContractById = (
  id,
  searchVal = "",
  saleStatus = [],
  startDate = "",
  endDate = "",
  page = 1,
  limit = 50
) => {
  const url = `${endPoints.getAllContractById}/${id}?search=${searchVal}&saleStatus=${saleStatus}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`;
  return Api(url, null, requestType.GET);
};

const getAllContract = (
  search = "",
  type = "All",
  saleStatus = [],
  startDate = "",
  endDate = "",
  page = 1,
  limit = 50,
  agents = []
) => {
  const url = `${endPoints.getAllContract}?search=${search}&type=${type}&saleStatus=${saleStatus}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}&agents=${agents}`;

  return Api(url, null, requestType.GET);
};

const getContractDetails = (id) => {
  return Api(`${endPoints.getContractDetail}/${id}`, null, requestType.GET);
};

const sendContractSummary = (params) => {
  return Api(endPoints.sendContractSummary, params, requestType.POST);
};

const deleteContract = (id) => {
  return Api(`${endPoints.deleteContract}/${id}`, null, requestType.DELETE);
};

const getFutureContract = (ids) => {
  const url =
    ids.length > 0
      ? `${endPoints.getFutureContract}?agent=${ids.join(",")}`
      : endPoints.getFutureContract;
  return Api(url, null, requestType.GET);
};

const updateContractAgent = (id, params) => {
  return Api(`${endPoints.updateContractAgent}/${id}`, params, requestType.PUT);
};

export {
  createContract,
  updateContract,
  sendContractPdf,
  getAllContractById,
  getAllContract,
  sendContractSummary,
  getContractDetails,
  deleteContract,
  updateContractStatuses,
  getfollowUpDates,
  createDuplicateContract,
  exportContract,
  getFutureContract,
  updateContractAgent,
};
